import type { TimestampedResource } from '@toolproof-core/genesis/_contract/_index';

import { fromTimestampedResourcesToResources } from '@toolproof-core/lib/_pure/cosmos-data-extraction';
import type { ResourcesByType } from '@toolproof-core/lib/_contract/resources';

import type { SpaceAdapterResourceTypeInputSpec } from '@toolproof-core/visualization/adapter/_contract/adapter';

import {
    PRESET_TIMESTAMPED_RESOURCES_BY_TYPE,
    RESOURCE_TYPE_REQUIREMENTS,
    TYPE_Boolean,
    TYPE_Natural,
    TYPE_ResourceType,
    TYPE_Tool,
} from '@/workflow/_data/config/fragments/resourceTypes';
import type { ResourceTypeRequirement } from '@/workflow/_contract/config';

export type ResourceTypeInputSpec =
    SpaceAdapterResourceTypeInputSpec<ResourceTypeRequirement>;

const WORKFLOW_PRESET_RESOURCE_COLLECTION_BY_TYPE: ResourcesByType<ResourceTypeRequirement> = {
    [TYPE_Tool]: fromTimestampedResourcesToResources(
        PRESET_TIMESTAMPED_RESOURCES_BY_TYPE[TYPE_Tool] as unknown as TimestampedResource[]
    ),
    [TYPE_ResourceType]: fromTimestampedResourcesToResources(
        PRESET_TIMESTAMPED_RESOURCES_BY_TYPE[TYPE_ResourceType] as unknown as TimestampedResource[]
    ),
    [TYPE_Boolean]: fromTimestampedResourcesToResources(
        PRESET_TIMESTAMPED_RESOURCES_BY_TYPE[TYPE_Boolean] as unknown as TimestampedResource[]
    ),
    [TYPE_Natural]: fromTimestampedResourcesToResources(
        PRESET_TIMESTAMPED_RESOURCES_BY_TYPE[TYPE_Natural] as unknown as TimestampedResource[]
    ),
};

export const RESOURCE_TYPE_INPUT_SPEC: ResourceTypeInputSpec = {
    requiredResourceTypes: RESOURCE_TYPE_REQUIREMENTS,
    presetResourcesByType: WORKFLOW_PRESET_RESOURCE_COLLECTION_BY_TYPE,
};

export function getResourceTypeInputSpec(): ResourceTypeInputSpec {
    return RESOURCE_TYPE_INPUT_SPEC;
}
